import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorageService} from 'ngx-webstorage';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-remove-cart-item',
  templateUrl: 'cart-dates-prompt.component.html',
  styleUrls: ['../my-cart/my-cart.component.scss'],
})
export class CartDatesPromptComponent implements OnInit {

  datesForm: FormGroup;
  datesArray = [];
  dates = [];

  ngOnInit() {
    this.createForm();
    if (this.localSt.retrieve('cartDates')) {
      if (this.localSt.retrieve('suggestedItemEndDate') && this.localSt.retrieve('suggestedItemEndDate') !== null) {
        this.datesArray = this.localSt.retrieve('cartDates');
        this.datesArray.forEach(date => {
          if (new Date(date).toISOString() <= this.localSt.retrieve('suggestedItemEndDate')) {
            this.dates.push(date);
          }
        });
      } else {
        this.dates = this.localSt.retrieve('cartDates');
      }
      this.datesForm.patchValue({date: this.dates[0]});
    }
  }

  constructor(private activeModal: NgbActiveModal,
              private localSt: LocalStorageService) {
  }

  private createForm() {
    this.datesForm = new FormGroup({
      date: new FormControl('', [Validators.required])
    });
  }

  closeModal(status) {
    this.localSt.clear('cartDates');
    this.localSt.clear('suggestedItemEndDate');
    this.activeModal.close({status: status, date: this.datesForm.value.date});
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/cart-dates-prompt/cart-dates-prompt.component.ts